/**
 * Aviso de Venta Nocturna del cart-sheet. Legacy y front nuevo solo pasan la
 * fase y los IDs guardados, sin reimplementar copy ni reglas. La huincha y el
 * contador de la campaña ya no viven en el navbar: los maneja cada host.
 */

export type VentaNocturnaPhase = 'off' | 'presale' | 'live';

export const VENTA_NOCTURNA_PATH = '/venta-nocturna';

// ── Aviso del carrito (cart notice) ─────────────────────────────────────────

export interface VentaNocturnaCartNotice {
  notice: string;
  noticeHref?: string;
}

const CART_NOTICE_COPY = {
  saved:
    '🌙 Tienes productos guardados para la Venta Nocturna. Si compras ahora pagas el precio actual; el descuento adicional estará disponible cuando comience la campaña.',
  outOfSync:
    '🌙 Tu carrito cambió desde que lo guardaste para la Venta Nocturna. Actualízalo para que el descuento adicional cubra todos tus productos.',
} as const;

const sortedKey = (ids: readonly string[]) => [...ids].sort().join(',');

/**
 * El aviso es solo para quien YA guardó su carrito de Venta Nocturna: guardado
 * y sincronizado → recordatorio; guardado y distinto → "actualízalo". Sin
 * snapshot guardado (incluye deslogueados) no se muestra nada.
 */
export function resolveVentaNocturnaCartNotice(
  phase: VentaNocturnaPhase,
  savedIds: readonly string[] | undefined,
  liveIds: readonly string[],
): VentaNocturnaCartNotice | null {
  if (phase !== 'presale') return null;
  if (!savedIds || savedIds.length === 0) return null;

  if (sortedKey(liveIds) === sortedKey(savedIds)) {
    return { notice: CART_NOTICE_COPY.saved };
  }

  return { notice: CART_NOTICE_COPY.outOfSync, noticeHref: VENTA_NOCTURNA_PATH };
}
